import axios from 'axios'
import { Toast } from 'vant'
import storage from '@/utils/storage'
import router from '@/router.js'
import store from '../store'

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 60000
})
service.interceptors.request.use(
  config => {
    config.headers.Authorization = 'Bearer ' + storage.token
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    const res = response.data
    if (Object.prototype.toString.call(response.data) === '[object ArrayBuffer]') {
      return res
    }
    if (res.code == 401) {
      Toast({
        message: '请登录后访问',
        forbidClick: true
      })
      localStorage.clear()
      setTimeout(() => {
        router.push({
          path: '/login',
          query: {
            path: window.btoa(router.currentRoute.fullPath)
          }
        })
      }, 1500)
      return
    }
    if (res.code == 400) {
        Toast(res.msg)
      return res
    }
    if ( res.code == 500) {
      if (res.msg!=null) {
        Toast(res.msg)
      }
      return res
    }
    if (res.code == 501) {
      Toast({
        message: '登录失效 请重新登录',
      })
      localStorage.clear()
      setTimeout(() => {
        router.push({
          path: '/login',
          query: {
            path: window.btoa(router.currentRoute.fullPath)
          }
        })
      }, 1500)
      return
    }
    if (/^\/admin-api/.test(response.config.url)) {
      if (res.code == 0) {
        return res
      } else {
        Toast(res.msg)
        return Promise.reject(new Error(res.msg))
      }
    } else {
      if (res.code != 200) {
        // Message({
        //   message: res.msg || '网络超时,请稍后再试',
        //   type: 'error',
        //   duration: 3 * 1000,
        //   showClose: true
        // })
        // return Promise.reject(new Error(res.msg))

        if (res.msg) {
          return Promise.reject(new Error(res.msg))
        } else {
          return res
        }
      } else {
        return res
      }
    }
  },
  error => {
    Toast('网络超时,请稍后再试')
    return Promise.reject(error)
  }
)
export default service
